(function () {
  function activateHealth3Item(item) {
    var content = item.closest('.health-3-content');
    if (!content) {
      return;
    }
    content.querySelectorAll('.health-3-item').forEach(function (i) {
      i.classList.remove('active');
    });
    item.classList.add('active');
  }

  function bindHealth3Item(item) {
    if (!item || item.dataset.a11yHealth3Bound === 'true') {
      return;
    }
    item.dataset.a11yHealth3Bound = 'true';
    item.addEventListener('mouseenter', function () {
      activateHealth3Item(item);
    });
    item.addEventListener('focusin', function () {
      activateHealth3Item(item);
    });
  }

  function initHealth3(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.health-3 .health-3-content .health-3-item').forEach(bindHealth3Item);
  }

  initHealth3(document);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      initHealth3(event.target);
    }
  });
})();
